const STAGE = {
  open: ["Open Bill", "bg-stone-100 text-stone-700 border-stone-300"],
  dapur: ["Di Dapur", "bg-amber-100 text-amber-800 border-amber-300"],
  checker: ["Di Checker", "bg-purple-100 text-purple-800 border-purple-300"],
  siap_bayar: ["Siap Bayar", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  paid: ["Lunas", "bg-emerald-600 text-white border-emerald-600"],
  cancelled: ["Batal", "bg-red-100 text-red-700 border-red-300"],
};

export const StageBadge = ({ stage, testId }) => {
  const [label, cls] = STAGE[stage] || [stage, ""];
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${cls}`}>
      {label}
    </span>
  );
};

export const StatCard = ({ label, value, icon: Icon, accent = "orange", testId, hint }) => {
  const tone = {
    orange: "bg-orange-50 text-orange-700",
    emerald: "bg-emerald-50 text-emerald-700",
    amber: "bg-amber-50 text-amber-700",
    stone: "bg-stone-100 text-stone-700",
  }[accent];
  return (
    <div className="gm-rise rounded-2xl border border-stone-200 bg-white p-5 shadow-sm" data-testid={testId}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-zinc-500">{label}</p>
          <p className="mt-2 font-mono text-2xl font-bold tabular-nums text-zinc-900 truncate" data-testid={`${testId}-value`}>{value}</p>
          {hint && <p className="mt-1 text-xs text-zinc-500">{hint}</p>}
        </div>
        {Icon && (
          <span className={`grid h-10 w-10 shrink-0 place-items-center rounded-xl ${tone}`}>
            <Icon className="h-5 w-5" />
          </span>
        )}
      </div>
    </div>
  );
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight text-zinc-900" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-zinc-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Empty = ({ icon: Icon, text, testId }) => (
  <div data-testid={testId} className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-stone-300 bg-white/60 px-6 py-16 text-center">
    {Icon && <Icon className="mb-3 h-10 w-10 text-stone-300" />}
    <p className="text-sm text-zinc-500">{text}</p>
  </div>
);

export const Panel = ({ children, className = "" }) => (
  <div className={`rounded-2xl border border-stone-200 bg-white shadow-sm ${className}`}>{children}</div>
);
